import { render, staticRenderFns } from "./end-of-year.vue?vue&type=template&id=6f2f74ac&"
import script from "./end-of-year.vue?vue&type=script&lang=js&"
export * from "./end-of-year.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports